import React, { useEffect, useState, useRef } from "react";
import { addData, getStoreData } from "../db";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import alertify from "alertifyjs";
// import { io } from "socket.io-client";
// import socket from "../socket";
import { getSocket } from "../socket";
import "../App.css"
import Analytics from "./analytics";
import { beepSound } from "../utils/sound";



const LiveOrders = () => {
  const [orders, setOrders] = useState({ liveOrders: 0, totalAmount: 0 });
  const [acceptOrders, setAcceptOrders] = useState({ liveAcceptOrder: 0, totalAcceptAmount: 0 });
  const [declinrOrders, setDeclineOrders] = useState({ liveDeclineOrder: 0, totalDeclineAmount: 0 });
  const [placedOrders, setPlacedOrders] = useState({ livePlacedOrder: 0, totalPlacedAmount: 0 });
  // const [topBusiness, setTopBusiness] = useState([]);
  const [topBusinesses, setTopBusinesses] = useState([]);
  const [allBusinesses, setAllBusinesses] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [searchText, setSearchText] = useState("");
  const [ordersAnalytics, setOrdersAnalytics] = useState([]);
  const effectRan = useRef(false);
  const audioRef = useRef(new Audio("./sound_button.mp3"));
  const overFiftyPoundaudioRef = useRef(new Audio("/Over_40_Cash_Order_comes_Please_confirm.mp3"));
  const suspectAudioRef = useRef(new Audio("/SUSPECTED.mp3"));
  const duplicateAudioRef = useRef(new Audio("/DUPLICATE.mp3"));
  const declinedAudioRef = useRef(new Audio("/Declined.mp3"));
  const reDeclinedAudioRef = useRef(new Audio("/Re-Declined.mp3"));
  const listenerAdd = useRef(false);

  useEffect(() => {
    const unlock = () => {
      audioRef.current.play().then(() => {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      });
      document.removeEventListener("click", unlock);
    };
    const fiftyPoundaudioRef = () => {
      overFiftyPoundaudioRef.current.play().then(() => {
        overFiftyPoundaudioRef.current.pause();
        overFiftyPoundaudioRef.current.currentTime = 0;
      });
      document.removeEventListener("click", fiftyPoundaudioRef);
    }
    const suspectedRef = () => {
      suspectAudioRef.current.play().then(() => {
        suspectAudioRef.current.pause();
        suspectAudioRef.current.currentTime = 0;
      });
      document.removeEventListener("click", suspectedRef);
    }
    const duplicateRef = () => {
      duplicateAudioRef.current.play().then(() => {
        duplicateAudioRef.current.pause();
        duplicateAudioRef.current.currentTime = 0;
      });
      document.removeEventListener("click", duplicateRef);
    }
    const declinedRef = () => {
      declinedAudioRef.current.play().then(() => {
        declinedAudioRef.current.pause();
        declinedAudioRef.current.currentTime = 0;
      });
      document.removeEventListener("click", declinedRef);
    }
    const reDeclinedRef = () => {
      reDeclinedAudioRef.current.play().then(() => {
        reDeclinedAudioRef.current.pause();
        reDeclinedAudioRef.current.currentTime = 0;
      });
      document.removeEventListener("click", reDeclinedRef);
    }
    document.addEventListener("click", unlock);
    document.addEventListener("click", fiftyPoundaudioRef);
    document.addEventListener("click", suspectedRef);
    document.addEventListener("click", duplicateRef);
    document.addEventListener("click", declinedRef);
    document.addEventListener("click", reDeclinedRef);
  }, []);
  useEffect(() => {

    const fetchData = async () => {
      try {
        // fetch("https://pos.bookyep.com/stats")
        // const res = await fetch("http://apiv3.com/Execute_mails/getOrderCalForSocket");
        const res = await fetch("https://api25.bookyup.co.uk/Execute_mails/getOrderCalForSocket");
        // const res = await fetch("https://apiv3.bookyep.com/Execute_mails/getOrderCalForSocket");
        const data = await res.json();
        if (data.oinfo != null) {
          data.oinfo.map((items) => {
            addData("orders", items);
          });
          if (data.orderStats != undefined) {
            setOrders(data.orderStats);
          }
        }
        if (data.orderAcceptStats != undefined) {
          setAcceptOrders(data.orderAcceptStats);
        }
        if (data.orderDeclineStats != undefined) {
          setDeclineOrders(data.orderDeclineStats);
        }
        if (data.orderPlacedStats != undefined) {
          setPlacedOrders(data.orderPlacedStats);
        }
        getTop10Bs();
        if (data.oinfo) {
          const today = new Date().toISOString().split("T")[0];
          // console.log(today)
          const todayPlacedOrders = data.oinfo.filter(
            o => o.order_date === today
          );

          setOrdersAnalytics(todayPlacedOrders);
        }
      } catch (err) {
        console.error("API Fetch Error:", err);
      }
    };
      // fetchData();
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchData(); 
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    if (effectRan.current === false) {
      fetchData();
      effectRan.current = true;
    }
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Update every second

    // Clear the interval when the component unmounts
    // return () => clearInterval(timerId);
    return () => {
      clearInterval(timerId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    }
  }, []);

  useEffect(() => {
    if(listenerAdd.current) return;
    listenerAdd.current = true;

    const socket = getSocket();
    socket.on("connect", () => {
      // console.log('connected to socket:', socket.id);
    });
    
    const recalcPlacedOrders = async () => {
      const today = new Date().toISOString().split("T")[0];
      const storeOrders = await getStoreData("orders");

      const placed = storeOrders.filter(
        o =>
          o.order_date === today &&
          o.order_status === "order_placed"
      );

      const totalAmount = placed.reduce(
        (sum, o) => sum + Number(o.total || 0),
        0
      );
      // console.log("placed",placed)
      setPlacedOrders({
        livePlacedOrder: placed.length,
        totalPlacedAmount: totalAmount
      });
    };
    
    const recalcDeclinedOrders = async () => {
      const today = new Date().toISOString().split("T")[0];
      const storeOrders = await getStoreData("orders");

      const decline = storeOrders.filter(
        o =>
          o.order_date === today && (o.order_status === "order_declined" || (o.order_status === "refunded" && o.total == o.refund_amount))
      );

      /* const declineTtlAmt = storeOrders.filter(
        o =>
          o.order_date === today && (o.order_status === "order_declined" || (o.order_status === "refunded" && o.total == o.refund_amount) || (o.order_status === "refunded" && o.total != o.refund_amount))
      ); */
      const declineTtlAmt = storeOrders.filter( o => {
        if(o.order_date === today && o.order_status === "order_declined"){
          return o.total;
        }else if(o.order_date === today && o.order_status === "refunded" && o.total == o.refund_amount){
          return o.total;
        }else if(o.order_date === today && o.order_status === "refunded" && o.total != o.refund_amount){
          // const ttl = o.refund_amount;
          return o.total = o.refund_amount;
        }
      })

      const totalAmount = declineTtlAmt.reduce(
        (sum, o) => sum + Number(o.total || 0),
        0
      );
      // console.log("decline", decline);
      // console.log("totalAmount", totalAmount);
      setDeclineOrders({
        liveDeclineOrder: decline.length,
        totalDeclineAmount: totalAmount
      });
    };

    const recalcAcceptOrders = async () => {
      const today = new Date().toISOString().split("T")[0];
      console.log('today =', today)
      const storeOrders = await getStoreData("orders");

      const accepted = storeOrders.filter(
        o =>
          o.order_date === today && (o.order_status === "order_accepted" ||  o.order_status === 'ready_to_pickup' || o.order_status === 'ready_to_collect' || o.order_status === 'ready_to_delivery' || o.order_status === 'pickedup' || o.order_status === 'deliverd')
      );
      console.log('accepted =', accepted)
      const totalAmount = accepted.reduce(
        (sum, o) => sum + Number(o.total || 0),
        0
      );
      console.log('totalAmount =', totalAmount)
      setAcceptOrders({
        liveAcceptOrder: accepted.length,
        totalAcceptAmount: totalAmount
      });
    };

    socket.on("orderUpdate", async (data) => {
      // console.log("Live update received", data);
      setOrders((prevState) => {
        return (
          {
            ...prevState,
            liveOrders: Number(prevState.liveOrders) + 1,
            totalAmount: Number(prevState.totalAmount) + Number(data.orderInfo.total)
          }
        );
      });
      /* setPlacedOrders((prevState) => {
        return (
          {
            ...prevState,
            livePlacedOrder: Number(prevState.livePlacedOrder) + 1,
            totalPlacedAmount: Number(prevState.totalPlacedAmount) + Number(data.orderInfo.total)
          }
        )
      }) */
      await addData("orders", data.orderInfo);
      await recalcPlacedOrders();
      const order = {
        ...data.orderInfo,
        order_date: data.orderInfo.order_date || new Date().toISOString(),
        order_time: data.orderInfo.order_time,
        order_status: "placed"
      };
      setOrdersAnalytics(prev => [...prev, order]);
      // alertify.set("notifier", "position", "bottom-left");
      /* alertify.success(
        `New order from ${data.orderInfo.bs_name}`, 6 
      ) */
      const maxLength = 8;
      const truncatedBsName = data.orderInfo.bs_name.length > maxLength ? `${data.orderInfo.bs_name.substring(0, maxLength)}..` : data.orderInfo.bs_name;

      const serviceType = data.orderInfo.order_type == 'pickup' ? 'C' : 'D';
      const paymentType = data.orderInfo.payment_type == 'COD' ? 'Cash' : 'Card';
      // console.log(typeof(data.orderInfo.total))
      if(data.orderInfo.payment_type == 'COD' && Number(data.orderInfo.total) > 40 && data.orderInfo.is_suspected =='no'){
        // console.log(1)
        // if(data.orderInfo.total > '40' && data.orderInfo.is_suspected =='no'){
          overFiftyPoundaudioRef.current.play().catch(() => {});
          alertify.set("notifier", "position", "top-right");
          alertify.notify(
            `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}`, 'cash-order-over-50-pound', 0 
          )
        // }
      }else if(data.orderInfo.is_suspected == 'moderate' || data.orderInfo.is_suspected == 'high'){
        // beepSound();
        suspectAudioRef.current.play().catch(() => {});
        alertify.set("notifier", "position", "top-right");
        alertify.notify(
          `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}, ${paymentType}, 🖨️No(S), 🕵️ `, 'printer-error-suspected', 0
        )
      }else if(data.orderInfo.is_suspected == 'no,duplicate' || data.orderInfo.is_suspected == 'low,duplicate'){
        // beepSound();
        duplicateAudioRef.current.play().catch(() => {});
        alertify.set("notifier", "position", "top-right");
        alertify.notify(
          `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}, ${paymentType}, 🖨️No(D), 📑`, "printer-error-duplicate", 0 
        )
      }else{
        // console.log(2)
        alertify.set("notifier", "position", "bottom-left");
        alertify.success(
          `New order from ${data.orderInfo.bs_name}, £${data.orderInfo.total}`, 6 
        )
      }
    });

    socket.on("orderAccept", async (data) => {
      console.log("Live update received", data);
      /* setAcceptOrders((prevState) => {
        return (
          {
            ...prevState,
            liveAcceptOrder: Number(prevState.liveAcceptOrder) + 1,
            totalAcceptAmount: Number(prevState.totalAcceptAmount) + Number(data.orderInfo.total)
          }
        );
      }); */
      /* setPlacedOrders((prevState) => {
        return (
          {
            ...prevState,
            livePlacedOrder: Number(prevState.livePlacedOrder) - 1,
            totalPlacedAmount: Number(prevState.totalPlacedAmount) - Number(data.orderInfo.total)
          }
        )
      }); */
      await addData("orders", data.orderInfo);
      await recalcAcceptOrders();
      await recalcPlacedOrders();
      getTop10Bs();
    });
    const handleOrderDecline = async (data) =>{
      // console.log('socket msg fire');
      await addData("orders", data.orderInfo);
      await recalcDeclinedOrders();
      await recalcPlacedOrders();
      const maxLength = 8;
      const truncatedBsName = data.orderInfo.bs_name.length > maxLength ? `${data.orderInfo.bs_name.substring(0, maxLength)}..` : data.orderInfo.bs_name;

      const serviceType = data.orderInfo.order_type == 'pickup' ? 'C' : 'D';
      const paymentType = data.orderInfo.payment_type == 'COD' ? 'Cash' : 'Card';

      declinedAudioRef.current.play().catch(() => {});
      alertify.set("notifier", "position", "top-right");
      // console.log("DECLINED EVENT ID:", data.orderInfo.id, Date.now());
      alertify.notify(
        `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}, ${paymentType}`, 'order-declined', 0 
      )
    }
    socket.off("declineOrder", handleOrderDecline);
    socket.on("orderDeclined", handleOrderDecline);
    // socket.on("orderDeclined", async (data) => {
    //   console.log("hello declined")
    //   // console.log("Live update received", data);
    //   /* setDeclineOrders((prevState) => {
    //     return (
    //       {
    //         ...prevState,
    //         liveDeclineOrder: Number(prevState.liveDeclineOrder) + 1,
    //         totalDeclineAmount: Number(prevState.totalDeclineAmount) + Number(data.orderInfo.total)
    //       }
    //     );
    //   }); */
    //   /* setPlacedOrders((prevState) => {
    //     return (
    //       {
    //         ...prevState,
    //         livePlacedOrder: Number(prevState.livePlacedOrder) - 1,
    //         totalPlacedAmount: Number(prevState.totalPlacedAmount) - Number(data.orderInfo.total)
    //       }
    //     )
    //   }); */
    //   await addData("orders", data.orderInfo);
    //   await recalcDeclinedOrders();
    //   await recalcPlacedOrders();
    //   const maxLength = 8;
    //   const truncatedBsName = data.orderInfo.bs_name.length > maxLength ? `${data.orderInfo.bs_name.substring(0, maxLength)}..` : data.orderInfo.bs_name;

    //   const serviceType = data.orderInfo.order_type == 'pickup' ? 'C' : 'D';
    //   const paymentType = data.orderInfo.payment_type == 'COD' ? 'Cash' : 'Card';

    //   declinedAudioRef.current.play().catch(() => {});
    //   alertify.set("notifier", "position", "top-right");
    //   console.log("DECLINED EVENT ID:", data.orderInfo.id, Date.now());
    //   alertify.notify(
    //     `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}, ${paymentType}`, 'order-declined', 0 
    //   )
    // });
    socket.on("orderReAccept", async (data) => {
      console.log("Live update received", data);
      /* setDeclineOrders((prevState) => {
        return (
          {
            ...prevState,
            liveDeclineOrder: Number(prevState.liveDeclineOrder) - 1,
            totalDeclineAmount: Number(prevState.totalDeclineAmount) - Number(data.orderInfo.total)
          }
        );
      }); */
      /* setAcceptOrders((prevState) => {
        return (
          {
            ...prevState,
            liveAcceptOrder: Number(prevState.liveAcceptOrder) + 1,
            totalAcceptAmount: Number(prevState.totalAcceptAmount) + Number(data.orderInfo.total)
          }
        );
      }); */
      await addData("orders", data.orderInfo);
      await recalcDeclinedOrders();
      await recalcAcceptOrders();
    });

    const handleOrderReDeclined = async (data) =>{
      console.log("Live update received", data);
      await addData("orders", data.orderInfo);
      await recalcAcceptOrders();
      await recalcDeclinedOrders();
      const maxLength = 8;
      const truncatedBsName = data.orderInfo.bs_name.length > maxLength ? `${data.orderInfo.bs_name.substring(0, maxLength)}..` : data.orderInfo.bs_name;

      const serviceType = data.orderInfo.order_type == 'pickup' ? 'C' : 'D';
      const paymentType = data.orderInfo.payment_type == 'COD' ? 'Cash' : 'Card';

      reDeclinedAudioRef.current.play().catch(() => {});
      alertify.set("notifier", "position", "top-right");
      alertify.notify(
        `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}, ${paymentType}`, 'order-re-declined', 0 
      )
    }
    // socket.on("orderReDeclined", async (data) => {
    //   console.log("Live update received", data);
    //   /* setAcceptOrders((prevState) => {
    //     return (
    //       {
    //         ...prevState,
    //         liveAcceptOrder: Number(prevState.liveAcceptOrder) - 1,
    //         totalAcceptAmount: Number(prevState.totalAcceptAmount) - Number(data.orderInfo.total)
    //       }
    //     );
    //   }); */
    //   /* setDeclineOrders((prevState) => {
    //     return (
    //       {
    //         ...prevState,
    //         liveDeclineOrder: Number(prevState.liveDeclineOrder) + 1,
    //         totalDeclineAmount: Number(prevState.totalDeclineAmount) + Number(data.orderInfo.total)
    //       }
    //     );
    //   }); */
    //   await addData("orders", data.orderInfo);
    //   await recalcAcceptOrders();
    //   await recalcDeclinedOrders();
    //   const maxLength = 8;
    //   const truncatedBsName = data.orderInfo.bs_name.length > maxLength ? `${data.orderInfo.bs_name.substring(0, maxLength)}..` : data.orderInfo.bs_name;

    //   const serviceType = data.orderInfo.order_type == 'pickup' ? 'C' : 'D';
    //   const paymentType = data.orderInfo.payment_type == 'COD' ? 'Cash' : 'Card';

    //   reDeclinedAudioRef.current.play().catch(() => {});
    //   alertify.set("notifier", "position", "top-right");
    //   alertify.notify(
    //     `${truncatedBsName} ${data.orderInfo.id}(${serviceType}), £${data.orderInfo.total}, ${paymentType}`, 'order-re-declined', 0 
    //   )
    // });
    socket.off("reDeclineOrder", handleOrderReDeclined);
    socket.on("orderReDeclined", handleOrderReDeclined);

    socket.on("orderRefunded", async (data) => {
      console.log("Live update received", data);
      await addData("orders", data.orderInfo);
      await recalcDeclinedOrders();
      await recalcAcceptOrders();
      await recalcPlacedOrders();
    });

    return () => {
      socket.off("orderUpdate");
      socket.off("orderAccept");
      socket.off("declineOrder", handleOrderDecline);
      socket.off("reDeclineOrder", handleOrderReDeclined);
      socket.off("reAcceptOrder");
      socket.off("refunded");
      socket.disconnect();
      listenerAdd.current = false;
    }
  }, []);
  useEffect(()=>{
    getTop10Bs();
  },[searchText]);

  const getTop10Bs = async () => {
    const today = new Date().toISOString().split("T")[0];
    const storeOrdersObj = await getStoreData('orders');
    // Filter for today's orders
    let filtered = storeOrdersObj.filter(item => item.order_date === today);
    if (searchText.trim()) {
      filtered = filtered.filter(
        item =>
          item.bs_name.toLowerCase().includes(searchText.toLowerCase()) ||
          item.bs_id.toString().includes(searchText)
      );
    }
    // console.log('filtered =', filtered);
    filtered = filtered.filter(item => item.order_status === 'order_accepted' || item.order_status === 'ready_to_pickup' || item.order_status === 'ready_to_delivery' || item.order_status === 'pickedup' || item.order_status === 'deliverd' || item.order_status === 'ready_to_collect')
    const merged = Object.values(
      filtered.reduce((acc, item) => {
        if (!acc[item.bs_id]) {
          // acc[item.bs_id] = { ...item };
          acc[item.bs_id] = {
            bs_id: item.bs_id,
            bs_name: item.bs_name,
            total: Math.max(0, item.total), // prevent negative
            order_count: 1 // count orders
          };
        } else {
          acc[item.bs_id].total = Math.max(
            0,
            Number(acc[item.bs_id].total) + Number(item.total)
          );
          acc[item.bs_id].order_count += 1; // increase count
        }
        return acc;
      }, {})
    );
    // console.log('merged =', merged);
    const sortedTop10 = merged.sort((a, b) => b.total - a.total).slice(0, 10);
    setTopBusinesses(sortedTop10);
    setAllBusinesses(merged);
  }
  return (
    <div className="final-menu-liveOrders overflow-auto">
      <Container>
        <div className="clock-container">
          <div className="date-display">{currentTime.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year:'numeric'})}</div>
          <div className="time-display">{currentTime.toLocaleTimeString('en-GB', { timeZone: 'Europe/London' })}</div>
        </div>
        <h3 className="text-center mt-2 mb-4 fw-bolder main-div text-black">Live Order Dashboard</h3>
        <Row className="justify-content-md-center">
          <Col lg={3}>
              <Card className="d-flex mx-auto mb-2"
                text={'white'}
                style={{ width: '100%', backgroundImage : 'url(../image/4.jpg)' }}
                >
                <Card.Header className="text-center">Total</Card.Header>
                <Card.Body className="px-2 py-2">
                  <Card.Title className="d-flex align-items-center justify-content-center m-0">
                    {
                       orders.liveOrders != undefined && orders.liveOrders != null && orders.liveOrders != '' ?
                        (
                          <p className="p-0 m-0 text-center h3">{orders.liveOrders}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">0</p>
                        )
                    } <p className="p-0 m-0 text-center h3"> / </p> {
                      orders.totalAmount != undefined ?
                        (
                          <p className="p-0 m-0 text-center h3">&pound; {parseFloat(orders.totalAmount).toFixed(2) || 0}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">&pound; 0.00</p>
                        )
                    }
                  </Card.Title>
                </Card.Body>
              </Card>
              <Card className="d-flex mx-auto mb-2"
                text={'white'}
                style={{ width: '100%',  backgroundImage : 'url(../image/3.jpg)'}}
                >
                <Card.Header className="text-center">Placed</Card.Header>
                <Card.Body className="px-2 py-2">
                  <Card.Title className="d-flex align-items-center justify-content-center m-0">
                    {
                      placedOrders.livePlacedOrder != undefined && placedOrders.livePlacedOrder != null && placedOrders.livePlacedOrder != '' ?
                        (
                          <p className="p-0 m-0 text-center h3">{placedOrders.livePlacedOrder}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">0</p>
                        )
                    } <p className="p-0 m-0 text-center h3"> / </p> {
                      placedOrders.totalPlacedAmount != undefined ?
                        (
                          <p className="p-0 m-0 text-center h3">&pound; {parseFloat(placedOrders.totalPlacedAmount).toFixed(2) || 0}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">&pound; 0.00</p>
                        )
                    }
                  </Card.Title>
                </Card.Body>
              </Card>
              <Card className="d-flex mx-auto mb-2"
                text={'white'}
                style={{ width: '100%',  backgroundImage : 'url(../image/2.jpg)'  }}
                >
                <Card.Header className="text-center">Accepted</Card.Header>
                <Card.Body className="px-2 py-2">
                  <Card.Title className="d-flex align-items-center justify-content-center m-0">
                    {
                      acceptOrders.liveAcceptOrder != undefined && acceptOrders.liveAcceptOrder != null && acceptOrders.liveAcceptOrder != '' ?
                        (
                          <p className="p-0 m-0 text-center h3">{acceptOrders.liveAcceptOrder}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">0</p>
                        )
                    } <p className="p-0 m-0 text-center h3"> / </p> {
                      acceptOrders.totalAcceptAmount != undefined ?
                        (
                          <p className="p-0 m-0 text-center h3">&pound; {parseFloat(acceptOrders.totalAcceptAmount).toFixed(2) || 0}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">&pound; 0.00</p>
                        )
                    }
                  </Card.Title>
                </Card.Body>
              </Card>
              <Card className="d-flex mx-auto mb-2"
                text={'white'}
                style={{ width: '100%', backgroundImage : 'url(../image/1.jpg)'}}
                  >
                <Card.Header className="text-center">Declined/Refunded</Card.Header>
                <Card.Body className="px-2 py-2">
                  <Card.Title className="d-flex align-items-center justify-content-center m-0">
                    {
                      declinrOrders.liveDeclineOrder != undefined && declinrOrders.liveDeclineOrder != null && declinrOrders.liveDeclineOrder != '' ?
                        (
                          <p className="p-0 m-0 text-center h3">{declinrOrders.liveDeclineOrder}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">0</p>
                        )
                    } <p className="p-0 m-0 text-center h3"> / </p> {
                      declinrOrders.totalDeclineAmount != undefined ?
                        (
                          <p className="p-0 m-0 text-center h3">&pound; {parseFloat(declinrOrders.totalDeclineAmount).toFixed(2) || 0}</p>
                        ) : (
                          <p className="p-0 m-0 text-center h3">&pound; 0.00</p>
                        )
                    }
                  </Card.Title>
                </Card.Body>
              </Card>
          </Col>
          <Col lg={9}>
            <Tabs
            defaultActiveKey="home"
            id="fill-tab-example"
            className="mb-3"
            fill
          >
            <Tab eventKey="home" title="🏆 Top 10 Businesses">
              <Table responsive="lg" className="table-wrapper">
                <thead>
                  <tr>
                    <th style={{ width: '10%'}} className="text-start">Rank</th>
                    <th style={{ width: '20%'}} className="text-center">Business Id</th>
                    <th style={{ width: '50%'}} className="text-center">Business Name</th>
                    {/* <th className="text-center">Total Order No</th> */}
                    <th style={{ width: '20%'}} className="text-end">Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    topBusinesses.map((item, index) => (
                      <tr key={index} className={
                              index === 0 ? "rank-1" :
                              index === 1 ? "rank-2" :
                              index === 2 ? "rank-3" : ""
                            }>
                        <td style={{ width: '10%'}} className="text-start">#{index + 1}</td>
                        <td style={{ width: '20%'}} className="text-center">{item.bs_id}</td>
                        <td style={{ width: '50%'}} className="text-center">{item.bs_name}</td>
                        {/* <td className="text-center">{item.order_count}</td> */}
                        <td style={{ width: '20%'}} className="text-end"><span>{item.order_count}</span><span> / </span><span>&pound; {parseFloat(item.total).toFixed(2)}</span></td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="profile" title="All Business">
              <Row>
                <Col lg={12}>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="mr-sm-2 mb-2"
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                  />
                  <Table responsive="lg" className="table-wrapper">
                    <thead>
                      <tr>
                        <th style={{ width: '10%'}} className="One text-start">Rank</th>
                        <th style={{ width: '20%'}} className="Two text-center">Business Id</th>
                        <th style={{ width: '50%'}} className="Three text-center">Business Name</th>
                        {/* <th className="text-center">Total Order No</th> */}
                        <th style={{ width: '20%'}} className="Four text-end">Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        allBusinesses.map((item, index) => (
                          <tr key={index} className={
                              index === 0 ? "rank-1" :
                              index === 1 ? "rank-2" :
                              index === 2 ? "rank-3" : ""
                            }>
                            <td style={{ width: '10%'}} className="One text-start">#{index + 1}</td>
                            <td style={{ width: '20%'}} className="Two text-center">{item.bs_id}</td>
                            <td style={{ width: '50%'}} className="Three text-center">{item.bs_name}</td>
                            {/* <td className="text-center"></td> */}
                            <td style={{ width: '20%'}} className="Four text-end"><span>{item.order_count}</span><span> / </span><span>&pound; {parseFloat(item.total).toFixed(2)}</span></td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="analytics" title="Order Analytics">
              {
                ordersAnalytics != undefined && <Analytics orders={ordersAnalytics} />
              }
            </Tab>
          </Tabs>
              
          </Col>
          
        </Row>
      </Container>
    </div>
  );
};

export default LiveOrders;